<template>
<!-- 开票详情 -->
    <div  class="Booking">
        <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="typeArea">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'UserInfo', params: { menuInx: '5' } }">我的钱包</el-breadcrumb-item>
                <el-breadcrumb-item class="bread">开票详情</el-breadcrumb-item>
            </el-breadcrumb>

            <div class="con">
                <div class="con-tit">
                    开票详情
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            订单编号
                        </div>
                        <div class="nr-c">
                            {{form.source_sn}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            订单类型
                        </div>
                        <div class="nr-c">
                            <!-- {{form.change_type == 103 ? '开通会员' : '上线发布舱位' }} -->
                            <span v-if="form.change_type == 103">开通会员</span>
                            <span v-if="form.change_type == 104">上线发布舱位</span>
                            <span v-if="form.change_type == 105">订舱服务费扣除</span>
                            <span v-if="form.change_type == 106">订舱亏舱费扣除</span>
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            交易金额
                        </div>
                        <div class="nr-c">
                            ￥{{form.change_amount}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            交易时间
                        </div>
                        <div class="nr-c">
                            {{form.create_time}}
                        </div>
                    </div>
                </div>
                <div class="con-tit">
                    操作人
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            操作人昵称
                        </div>
                        <div class="nr-c">
                            {{check_admin.name || '--'}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            操作人电话
                        </div>
                        <div class="nr-c">
                            {{check_admin.account || '--'}}
                        </div>
                    </div>
                </div>
                <div class="con-tit">
                    开票信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            开票状态
                        </div>
                        <div class="nr-c">
                            <span v-if="form.invoice_status==0">不可开票订单</span>
                            <span v-if="form.invoice_status==1">待开票</span>
                            <span v-if="form.invoice_status==2">开票中</span>
                            <span v-if="form.invoice_status==3">已开票</span>
                            <span v-if="form.invoice_status==4">已驳回</span>
                        </div>
                    </div>
                    <div class="nr nryi"  v-if="form.invoice_status == 4">
                        <div class="nr-t">
                            驳回时间
                        </div>
                        <div class="nr-c">
                            {{form.fapiao.check_time}}
                        </div>
                    </div>
                    <div class="nr nryi" v-if="form.invoice_status == 3">
                        <div class="nr-t">
                            电子发票
                        </div>
                        <el-button class="click" @click="FaPiaoVisible = true">点击查看</el-button>
                    </div>
                </div>
                <!-- 已驳回 -->
                <div class="neirong" v-if="form.invoice_status == 4">
                    <div class="nr">
                        <div class="nr-t">
                            驳回原因
                        </div>
                        <div class="nr-c nr-csan">
                            {{form.fapiao.reject_reason}}
                        </div>
                    </div>
                </div>
                <div class="btn" v-if="form.invoice_status == 1 || form.invoice_status == 4">
                    <!-- <el-button>返回</el-button> -->
                    <el-button class="shenq"  v-if="form.invoice_status == 1" @click="getUserAuthentication">申请开票</el-button>
                    <el-button class="shenq"  v-if="form.invoice_status == 4" @click="getUserAuthentication">重新开票</el-button>
                </div>
            </div>
        </div>

        <!-- 开发票对话框 -->
        <el-dialog center class="dialog" title="申请开票" :visible.sync="dialogFormVisible">
            <div class="tit">
                开票须知
            </div>
            <div class="tx">开票信息为认证时所填写的资料如需修改请联系客服</div>
            <div class="fap">
                <div>发票金额：</div>
                <div class="jine">￥{{form.change_amount}}</div>
            </div>
            <div  class="fap">
                <div>发票内容：</div>
                <div class="fangs">
                    <span v-if="form.change_type == 103">开通会员</span>
                    <span v-if="form.change_type == 104">上线发布舱位</span>
                    <span v-if="form.change_type == 105">订舱服务费扣除</span>
                    <span v-if="form.change_type == 106">订舱亏舱费扣除</span>
                </div>
                <!-- <el-input v-model="dialogForm.content" autocomplete="off" placeholder="请输入"/> -->
            </div>
            <div  class="fap">
                <div>币种：</div>
                <div>
                    <el-radio v-model="dialogForm.coin_type" @change="dianji" :label="1">CNY</el-radio>
                    <el-radio v-model="dialogForm.coin_type" @change="dianji" :label="2">USD</el-radio>
                </div>
            </div>
            <el-form>
                <el-form-item label="发票抬头">
                    <el-input placeholder="请输入认证时的数据" disabled v-model="dialogForm.enterprise_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="税务登记号">
                    <el-input placeholder="请输入认证时的数据" disabled v-model="dialogForm.taxpayer_id" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="银行账号">
                    <el-input placeholder="请输入认证时的数据" disabled v-model="dialogForm.bank_account" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开户行">
                    <el-input placeholder="请输入认证时的数据" disabled v-model="dialogForm.bank_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱">
                    <el-input placeholder="请输入认证时的数据" disabled v-model="dialogForm.email" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div  class="dialog-footer">
                <el-button class="quxiao" @click="dialogFormVisible = false">返回</el-button>
                <el-button class="queren" type="primary" @click="tijiao">申请开票</el-button>
            </div>
        </el-dialog>

        <!-- 电子发票  已开票 -->
        <el-dialog center class="dialog" title="电子发票" :visible.sync="FaPiaoVisible">
            <img class="tupp" :src="fapiao.fapiaofile" alt="" />
            <div  class="dialog-footer">
                <el-button class="quxiao" @click="FaPiaoVisible = false">返回</el-button>
                <el-button class="queren" type="primary" @click="FaPiaoVisible = false">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import TopNavigation from "../HP/TopNavigationB.vue";
import { orderFapiaoDetails,applyFapiao,userAuthenticationInfo } from "@/api/api";
export default {
    components:{
        TopNavigation,
    },
    data() {
        return {
            // 交易状态
            // 0 未申请  1 开票中  2 已开票  3 已驳回
            transactionStatus:2,
            dialogFormVisible: false,
            // 发票单选框
            radio:'1',
            // 查看发票
            FaPiaoVisible: false,
            headers: {
                token: localStorage.getItem("token"),
            },
            canshu:{},
            form:{},
            dialogForm:{
                account_log_id:'',
                coin_type:1,
                enterprise_name:'',
                taxpayer_id:'',
                bank_name:'',
                bank_account:'',
                email:'',
                money:'',
                content:'',
            },
            fapiao:{},
            bankName:{
                cny_bank_account:'',
                cny_bank_name:'',
                usd_bank_account:'',
                usd_bank_name:'',
            },
            check_admin:{
                name:'',
                account:'',
            },
        }
    },
    methods: {
        async tijiao(){
            this.dialogForm.account_log_id = this.$route.query.id
            this.dialogForm.money = this.form.change_amount

            if (this.form.change_type==103) {
                this.dialogForm.content ='开通会员'
            }else if (this.form.change_type==104) {
                this.dialogForm.content ='上线发布舱位'
            }else if (this.form.change_type==105) {
                this.dialogForm.content ='订舱服务费扣除'
            }else if (this.form.change_type==106) {
                this.dialogForm.content ='订舱亏舱费扣除'
            }

            try {
                const res = await applyFapiao(this.dialogForm,this.headers)
                if(res.code==1){
                    this.$message({
                        type:'success',
                        message:'提交成功'
                    })
                    this.$router.push({
                        name:'UserInfo',
                        params:{
                            menuInx:5
                        }
                    })
                    this.dialogFormVisible = false;
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async getDetail(){
            try {
                const res = await orderFapiaoDetails({
                    account_log_id:this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.form = res.data
                    this.fapiao = res.data.fapiao
                    if(this.form.check_admin.name!=undefined){
                        this.check_admin.name = this.form.check_admin.name
                    }
                    if(this.form.check_admin.account!=undefined){
                        this.check_admin.account = this.form.check_admin.account
                    }
                    // this.fapiao.is_check = this.form.fapiao.fapiao.is_check
                }
            } catch (error) {
                console.log(error,'提现详情获取失败');
            }
        },
        // 获取认证信息
        async getUserAuthentication(){
            this.dialogFormVisible = true
            try {
                const res = await userAuthenticationInfo(this.headers);
                if (res.code == 1) {
                    this.dialogForm.enterprise_name = res.data.enterprise_name;
                    this.dialogForm.taxpayer_id = res.data.taxpayer_id;
                    this.dialogForm.email = res.data.email;
                    this.dialogForm.bank_account = res.data.bank_account;
                    this.dialogForm.bank_name = res.data.bank_name;

                    this.bankName.cny_bank_account = res.data.cny_bank_account;
                    this.bankName.cny_bank_name = res.data.cny_bank_name;
                    this.bankName.usd_bank_account = res.data.usd_bank_account;
                    this.bankName.usd_bank_name = res.data.usd_bank_name;

                    if(this.dialogForm.coin_type==1){
                        this.dialogForm.bank_account = res.data.cny_bank_account;
                        this.dialogForm.bank_name = res.data.cny_bank_name;
                    }else{
                        this.dialogForm.bank_account = res.data.usd_bank_account;
                        this.dialogForm.bank_name = res.data.usd_bank_name;
                    }
                }
            } catch (error) {
                console.log(error,"获取用户认证信息失败");
            }
        },
        dianji(){
            // console.log(11111,this.dialogForm.bank_account);
            if(this.dialogForm.coin_type==1){
                this.dialogForm.bank_account =this.bankName.cny_bank_account;
                this.dialogForm.bank_name =this.bankName.cny_bank_name;
            }else{
                this.dialogForm.bank_account =this.bankName.usd_bank_account;
                this.dialogForm.bank_name =this.bankName.usd_bank_name;
            }
        }
    },
    mounted(){
        this.getDetail()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}

.con{
    // height: 888px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 32px;
    box-sizing: border-box;

    position: relative;

    margin-bottom: 24px;
    .con-tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        padding-top: 12px;
        padding-bottom: 24px;

    }

    .neirong{
        display: flex;
        margin-bottom: 20px;
        .nr{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }

        .click{
            width: 100px;
            height: 40px;
            background: #0073F5;
            border-radius: 8px 8px 8px 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            font-style: normal;
            text-transform: none;
            border: 0;
        }

        .nryi{
            margin-left: 40px;  
        }


        .nr-t{
            width: 85px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 10px;
        }

        .nr-c{
            width: 260px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            
            padding: 10px 12px;

            box-sizing: border-box;
        }
        .nr-csan{
            width: 1044px;
            height: 200px;
            margin: 0;
        }
        .dongjie{
            display: flex;
            align-items: center;
            span{
                display: inline-block;

                // width: 48px;
                padding: 0 8px;
                height: 20px;
                background: #EDF6FF;
                border-radius: 4px 4px 4px 4px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #0073F5;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }
    }

    .btn{
        text-align: center;
        // position: absolute;
        // bottom: 32px;
        // left: 50%;
        .el-button{
            width: 100px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 8px 8px 8px 8px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;
            border: 0;
        }

        .shenq{
            color: #fff;
            background: #0073F5;
            margin-left: 16px;
            margin-top: 100px;
        }
    }
}

.dialog{
    .el-form{
        border-bottom: solid 1px #eee;
    }

    
    :deep(.el-dialog){
        width: 480px ;
        .el-form-item__label{
            width: 84px;
            font-size: 14px;
            color: #999999;
            text-align: left;
            margin-left: 26px;
        }

        .el-input{
            margin-bottom: 16px;
            width: 164px;
            input{
                width: 320px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;

                border: 0;
            }
        }
    }

    .quxiao{
        width: 100px;
        height: 40px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        color: #999999;
        border: 0;

        margin-top: 20px;
    }

    .queren{
        width: 100px;
        height: 40px;
        background: #0073F5;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        border: 0;
        margin-left: 16px;
        margin-top: 20px;
    }

    .fap{
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        margin-bottom: 24px;
        div:first-child{
            width: 84px;
            text-align: right;
        }
        .jine{
            color: #FE3300;
        }

        .fangs{
            color: #333333;
        }
    }

    .tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .tx{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        margin-bottom: 24px;
        margin-top: 4px;
    }

    .dialog-footer{
        text-align: right;
    }
}

// 单选按钮警告错误
::v-deep .el-radio__original {
  display: none !important;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}

.tupp {
  width: 100%;
}
</style>